module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"pt-BR":{"navbar-title":"Contato","title":"Seu contato","description":"Usaremos esta informação apenas para garantir que tenha acesso às suas fotos de maneira segura.","next":"Avançar","validation-error":"Há algum problema nas informações fornecidas. Verifique as mensagens de erro em cada campo."}}')
  delete Component.options._Ctor
}
